import React, { useEffect, useState } from "react";
import backarrow from "../assets/backwardarrow.svg";
import { Link, useNavigate, useParams } from "react-router-dom";
import { get, off, onValue, ref, update } from "firebase/database";
import { push } from "firebase/database";
import { auth, db, storage } from "../utilities/firebaseConfig";
import Chat from "./TechncianChat";
import TaskProgressUpdate from "../technician/TaskProgressUpdate";
import activeimg from "../assets/activ.svg";
import { getDownloadURL, uploadBytes } from "firebase/storage";
import { ref as storageRef } from "firebase/storage";
import { ref as dbRef } from "firebase/database";
import timeicon from "../assets/ttime.svg";
import calendericon from "../assets/tcalendar.svg";
import locationicon from "../assets/tlocation.svg";
import taskicon from "../assets/taskimgicon.svg";
import moneyicon from "../assets/moneyicon.svg";
import TechnicianDashboardLayout from "../components/TechnicianDashboardLayout";
import sendimg from "../assets/sendicon.svg";
import useNotification from "../utilities/NotificationServices";


function TaskDetails() {
  const { notifyNewMessage } = useNotification();
  const { taskId } = useParams();
  const [task, setTask] = useState(null);
  const navigate = useNavigate();
  const [job, setJob] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [show, setShow] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [lastStartCode, setLastStartCode] = useState(null);
  const [inputCode, setInputCode] = useState("");
  const [error, setError] = useState("");
  const [startTime, setStartTime] = useState(null);
  const [elapsedTime, setElapsedTime] = useState(0);

  const [isPaused, setIsPaused] = useState(false);
  const [pauseTime, setPauseTime] = useState(null);
  const [completeCode, setCompleteCode] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [status, setStatus] = useState("");
  const [file, setFile] = useState(null);
  const [tasksum, setTasksum] = useState(false);
  const [showChat, setShowChatModal] = useState(false);
  const [messages, setMessages] = useState([]);
  const [newMsg, setNewMsg] = useState("");
  const [userName, setUserName] = useState("");
  const [proofFile, setProofFile] = useState(null);

  // Fetch job data and listen for changes
  useEffect(() => {
    const jobRef = ref(db, `jobs/${taskId}`);
    const listener = onValue(jobRef, (snapshot) => {
      if (snapshot.exists()) {
        const jobData = snapshot.val();
        setTask(jobData);

        if (jobData.startCode && jobData.startCode !== lastStartCode) {
          setShowSuccessModal(true);
          setLastStartCode(jobData.startCode);

          setTimeout(() => {
            setShowSuccessModal(false);
          }, 3000);
        }

        if (jobData.startTime) {
          setStartTime(jobData.startTime);
        }

        setIsPaused(jobData.isPaused || false);
        setPauseTime(jobData.pauseTime || null);
        setStatus(jobData.status || "");
      }
    });

    return () => off(jobRef, "value", listener);
  }, [taskId, lastStartCode]);

  // Calculate elapsed time
  // 🕒 Stopwatch logic
  useEffect(() => {
    let interval;
    if (startTime && !isPaused) {
      interval = setInterval(() => {
        setElapsedTime(Date.now() - startTime);
      }, 1000);
    } else if (isPaused && startTime && pauseTime) {
      // Set elapsed time manually if paused
      setElapsedTime(pauseTime - startTime);
    }

    return () => clearInterval(interval);
  }, [startTime, isPaused, pauseTime]);

  // Fetch chat messages for this job.
  useEffect(() => {
    const chatRef = ref(db, `chats/${taskId}`);
    onValue(chatRef, (snapshot) => {
      const data = snapshot.val();
      const msgs = data ? Object.values(data) : [];
      setMessages(msgs);
    });
  }, [taskId]);

  // Fetch the current user's name from the realtime database.
  useEffect(() => {
    const currentUser = auth.currentUser;
    if (currentUser) {
      const uid = currentUser.uid;
      const userRef = ref(db, `users/${uid}`);
      get(userRef)
        .then((snapshot) => {
          if (snapshot.exists()) {
            const userData = snapshot.val();
            setUserName(userData.name || "User");
          } else {
            setUserName("User");
          }
        })
        .catch((error) => {
          console.error("Error fetching user profile:", error);
          setUserName("User");
        });
    } else {
      navigate(`/job/${taskId}`);
    }
  }, [navigate, taskId]);

  // const sendMessagee = () => {
  //   if (newMsg.trim() === "") return;
  //   const currentUser = auth.currentUser;
  //   // Use the name fetched from the database (userName) for senderName.
  //   const senderName = userName || "User";
  //   const messageData = {
  //     sender: currentUser.uid,
  //     senderName:
  //       task.activeprofile.name +
  //       " " +
  //       task.activeprofile.lastName +
  //       " " +
  //       "(Service provider)",
  //     message: newMsg,
  //     timestamp: Date.now(),
  //   };
  //   push(ref(db, `chats/${taskId}`), messageData);
  //   setNewMsg("");
  // };

  const sendMessage = async () => {
    if (newMsg.trim() === "") return;
    const currentUser = auth.currentUser;
    if (!currentUser) return;

    const senderName = userName || "User";
    const messageData = {
      sender: currentUser.uid,
      senderName:
        task.activeprofile.name +
        " " +
        task.activeprofile.lastName +
        " " +
        "(Service provider)",
      message: newMsg,
      timestamp: Date.now(),
    };

    try {
      // Save message to database
      await push(ref(db, `chats/${taskId}`), messageData);

      // Send notification to the other party
      const recipientId =
        currentUser.uid === job.userId ? job.technicianId : job.userId;

      if (recipientId) {
        await notifyNewMessage(
          {
            id: currentUser.uid,
            name: senderName,
          },
          recipientId,
          taskId
        );
      }

      setNewMsg("");
    } catch (error) {
      console.error("Error sending message:", error);
    }
  };
  const formatWhatsAppTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    // Check if the date is today
    const isToday = date.toDateString() === now.toDateString();
    // Check if the date is yesterday
    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);
    const isYesterday = date.toDateString() === yesterday.toDateString();

    if (isToday) {
      // Show only time if today.
      return date.toLocaleTimeString(undefined, {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      });
    } else if (isYesterday) {
      // Show "Yesterday, HH:MM AM/PM"
      return `Yesterday, ${date.toLocaleTimeString(undefined, {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      })}`;
    } else {
      // Otherwise, show full date and time.
      return (
        date.toLocaleDateString(undefined, {
          weekday: "short",
          month: "short",
          day: "numeric",
          year: "numeric",
        }) +
        ", " +
        date.toLocaleTimeString(undefined, {
          hour: "numeric",
          minute: "numeric",
          hour12: true,
        })
      );
    }
  };

  // 🧮 Format milliseconds to mm:ss
  const formatTime = (ms) => {
    const totalSeconds = Math.floor(ms / 1000);
    const minutes = Math.floor(totalSeconds / 60)
      .toString()
      .padStart(2, "0");
    const seconds = (totalSeconds % 60).toString().padStart(2, "0");
    return `${minutes}:${seconds}`;
  };

  const handleStart = async () => {
    const jobRef = ref(db, `jobs/${taskId}`);
    const snapshot = await get(jobRef);

    if (snapshot.exists()) {
      const jobData = snapshot.val();
      if (inputCode === jobData.startCode) {
        const now = Date.now();
        await update(jobRef, {
          startTime: now,
          status: "in progress",
          jobstart: Date.now(),
          isPaused: false,
          pauseTime: null,
        });
        setError("");
        setStartTime(now);
      } else {
        setError("Incorrect code. Please try again.");
      }
    }
  };

  const handlePause = async () => {
    const jobRef = ref(db, `jobs/${taskId}`);
    const now = Date.now();
    await update(jobRef, {
      isPaused: true,
      pauseTime: now,
    });
    setIsPaused(true);
    setPauseTime(now);
  };

  const handleResume = async () => {
    const jobRef = ref(db, `jobs/${taskId}`);
    const now = Date.now();
    const adjustedStartTime = startTime + (now - pauseTime);

    await update(jobRef, {
      isPaused: false,
      pauseTime: null,
      startTime: adjustedStartTime,
    });

    setStartTime(adjustedStartTime);
    setPauseTime(null);
    setIsPaused(false);
  };

  const handleComplete = async () => {
    const jobRef = ref(db, `jobs/${taskId}`);
    const snapshot = await get(jobRef);

    if (snapshot.exists()) {
      const jobData = snapshot.val();
      if (completeCode === jobData.completeCode) {
        const now = Date.now();
        const finalElapsedTime = isPaused
          ? pauseTime - startTime
          : now - startTime;
        const totalHours = (finalElapsedTime / (1000 * 60 * 60)).toFixed(2);

        await update(jobRef, {
          status: "completed",
          completedAt: now,
          isPaused: true,
          pauseTime: Date.now(),

          totalTimeInHours: parseFloat(totalHours),
          totalamount: parseFloat(
            totalHours * task.hourlyRate + task.trustSupportFee
          ),
        });

        setElapsedTime(finalElapsedTime); // ⏱ Freeze the time
        setStatus("completed");
        setSuccessMsg(
          `Task completed successfully. Total time: ${totalHours} hours`
        );
      } else {
        setError("Incorrect completion code. Please try again.");
      }
    }
  };

  const handleFileChange = (e) => {
    if (e.target.files[0]) setFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    if (!file) return;
    const fileRef = storageRef(storage, `proofs/${taskId}/${file.name}`);
    try {
      const snapshot = await uploadBytes(fileRef, file);
      const url = await getDownloadURL(snapshot.ref);
      await update(dbRef(db, `jobs/${taskId}`), { proofUrl: url });
      alert("Proof uploaded successfully.");
    } catch (error) {
      console.error("Error uploading file:", error.message);
    }
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    // Arrays for the short names of days and months.
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    // Get the components of the date.
    const dayName = days[date.getDay()];
    const monthName = months[date.getMonth()];
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();

    return `${dayName}, ${monthName} ${day}, ${year}`;
  }

  const formatPrice = (price) => {
    if (!price) return "";
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  if (!task) return <p>Loading job details...</p>;

  const getTimeFromTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const seconds = date.getSeconds().toString().padStart(2, "0");
    return `${hours}:${minutes}:${seconds}`;
  };

  const handleProofChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      setProofFile({ file, preview: reader.result });
    };
    reader.readAsDataURL(file);

    e.target.value = null;
  };

  const handleProfileDeleteImage = () => {
    setProofFile(null);
  };

  const saveProofDetails = async () => {
    try {
      let proofimage = "";

      if (proofFile) {
        const profileRef = storageRef(storage, `jobs/${taskId}/proofworkimage`);
        await uploadBytes(profileRef, proofFile.file);
        proofimage = await getDownloadURL(profileRef);
      }

      // Ensure selectedServices is stored with a default price (0)

      await update(ref(db, `jobs/${taskId}`), {
        proofimage,
      });
    } catch (error) {
      console.error("Error saving details:", error);
      alert("Failed to save details. Please try again.");
    }
  };

  return (
    <>
      {/* {showSuccessModal && (
        <div className='successmodal'>
          <h1 className='successtitle'>Notification!</h1>
          <p className='successpaa'>
            Client have generated start code, kindly ask the client to share you
            the code.
          </p>
        </div>
      )} */}
      <TechnicianDashboardLayout>
        <div className='theclientdsh'>
          <button
            className='tdtback'
            onClick={() => navigate("/technician/dashboard")}
          >
            {/* <svg
              xmlns='http://www.w3.org/2000/svg'
              viewBox='0 0 24 24'
              width='48'
              height='48'
              fill='currentColor'
            >
              <path d='M10.8284 12.0007L15.7782 16.9504L14.364 18.3646L8 12.0007L14.364 5.63672L15.7782 7.05093L10.8284 12.0007Z'></path>
            </svg> */}
            Back to Dashboard
          </button>
          <div className='skhs'>
            <h1 className='jobtilsasd'>{task.jobtitle}</h1>

            <div className='skhsright'>
              <button
                className='skrschat'
                onClick={() => setShowChatModal(true)}
              >
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  viewBox='0 0 24 24'
                  height='24'
                  width='24'
                  fill='#fff'
                >
                  <path d='M7.29117 20.8242L2 22L3.17581 16.7088C2.42544 15.3056 2 13.7025 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C10.2975 22 8.6944 21.5746 7.29117 20.8242Z'></path>
                </svg>
              </button>
            </div>
          </div>
          <div className='thespacee'></div>
          <div className='jsdeetsep'>
            <div className='jsdeetsepleft'>
              <div className='jdetailsstatus'>
                <div className={`jdboxcircle ${task.status}bx`}></div>
                <p className={`jdboxtext ${task.status}`}>{task.status}</p>
              </div>
              <div className='thespacee'></div>
              <p className='jdetailscnt'>Task info</p>
              <div className='thespace'></div>
              <div className='jdetailsitems'>
                <div className='jdtsitem'>
                  <div className='jdtsitemleft'>
                    <img
                      src={calendericon}
                      alt=''
                      className='jdtsitemlefticon'
                    />
                    <p className='jdtsitempar'>Date</p>
                  </div>
                  <div className='jdtsitemright'>
                    <p className='jdtsitemapars'>{formatDate(task.date)}</p>
                  </div>
                </div>
                <div className='thespace'></div>
                <div className='dividar'></div>
                <div className='thespace'></div>
                <div className='jdtsitem'>
                  <div className='jdtsitemleft'>
                    <img
                      src={locationicon}
                      alt=''
                      className='jdtsitemlefticon'
                    />
                    <p className='jdtsitempar'>Location</p>
                  </div>
                  <div className='jdtsitemright'>
                    <p className='jdtsitemapars'>{task.address}</p>
                  </div>
                </div>
                <div className='thespace'></div>
                <div className='dividar'></div>
                <div className='thespace'></div>
                <div className='jdtsitem'>
                  <div className='jdtsitemleft'>
                    <img src={timeicon} alt='' className='jdtsitemlefticon' />
                    <p className='jdtsitempar'>Projected time</p>
                  </div>
                  <div className='jdtsitemright'>
                    {task.timeOfDay === "morning" && (
                      <p className='jdtsitemapars'>
                        {task.timeOfDay} <span>Before 10am</span>
                      </p>
                    )}
                    {task.timeOfDay === "midday" && (
                      <p className='jdtsitemapars'>
                        {task.timeOfDay} <span>10am - 2pm</span>
                      </p>
                    )}
                    {task.timeOfDay === "afternoon" && (
                      <p className='jdtsitemapars'>
                        {task.timeOfDay} <span>2pm - 6pm</span>
                      </p>
                    )}
                    {task.timeOfDay === "evening" && (
                      <p className='jdtsitemapars'>
                        {task.timeOfDay} <span>After 6pm</span>
                      </p>
                    )}
                  </div>
                </div>
                <div className='thespace'></div>
                <div className='dividar'></div>
                <div className='thespace'></div>
                <div className='jdtsitem'>
                  <div className='jdtsitemleft'>
                    <img src={moneyicon} alt='' className='jdtsitemlefticon' />
                    <p className='jdtsitempar'>Price breakdown</p>
                  </div>
                  <div className='jdtsitemright'>
                    <div className='jdtsitemrightitem'>
                      <p className='jtsitpal'>Hourly rate</p>
                      <p className='jtsitpar'>
                        ₦{formatPrice(task.hourlyRate)}/hr
                      </p>
                    </div>
                    <div className='jdtsitemrightitem'>
                      <p className='jtsitpal'>Trust/support fee</p>
                      <p className='jtsitpar'>
                        ₦{formatPrice(task.trustSupportFee)}
                      </p>
                    </div>
                    <div className='jdtsitemrightitem'>
                      <p className='jtsitpal'>Total fee</p>
                      <p className='jtsitpar'>₦{formatPrice(task.totalFee)}</p>
                    </div>
                  </div>
                </div>
                <div className='thespace'></div>
                <div className='dividar'></div>
                <div className='thespace'></div>
                <div className='jdtsitem'>
                  <div className='jdtsitemleft'>
                    <img src={taskicon} alt='' className='jdtsitemlefticon' />
                    <p className='jdtsitempar'>Task details/notes</p>
                  </div>
                  <div className='jdtsitemright'>
                    <div className='jdtsitemrightparcnt'>
                      <p className='jdtsitemaparss'>{task.jobdescription}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className='thespacee'></div>

              <div className='thespace'></div>

              <div className='thespacee'></div>
            </div>{" "}
            <div className='jsdeetsepright'>
              <div className='jdtechas'>
                <div className=''>
                  <div className='ljkah'>
                    <p className='lkajsdh'>
                      Client:{" "}
                      <span>
                        {task.userName} {task.userSurname}
                      </span>
                    </p>
                  </div>
                  <div className='thespace'></div>
                  <div className='dividar'></div>
                  <div className='thespacee'></div>
                  <div className='thewidepagerighttp'>
                    <img src={activeimg} alt='' />
                    <p className='twprtptitle'>Activity information</p>
                  </div>
                  <div className='thespace'></div>
                  {task.status === "completed" && (
                    <div className='thewidepagetimestartt'>
                      <div className='thesialse'>
                        <p className='thewidgptitle'>Total Completion task</p>
                        <p className='thwispte'>
                          {task.totalTimeInHours} Hours
                        </p>
                      </div>
                      <div className='thespace'></div>
                      <div className='thewidepas'>
                        <button
                          className='thewisptebtn'
                          onClick={() => setTasksum(true)}
                        >
                          View task summary
                        </button>
                      </div>
                    </div>
                  )}
                  {task.status === "in progress" && (
                    <div className='thesialse'>
                      <p className='thewidgptitle'>Task current time</p>
                      <div className=''></div>
                      {startTime ? (
                        <p className='thwispte'>{formatTime(elapsedTime)}</p>
                      ) : (
                        <p className='thwispte'>0:00</p>
                      )}
                    </div>
                  )}
                  {task.status === "accepted" && task.startTime && (
                    <>
                      {!isPaused ? (
                        <button className='thewisptebtn' onClick={handlePause}>
                          Pause task
                        </button>
                      ) : (
                        <button className='thewisptebtn' onClick={handleResume}>
                          Resume task
                        </button>
                      )}
                    </>
                  )}
                  {error && <p style={{ color: "red" }}>{error}</p>}
                  {task.startCode && !task.jobstart && !task.completedAt && (
                    <div className='inputjobcnt'>
                      <input
                        type='text'
                        value={inputCode}
                        onChange={(e) => setInputCode(e.target.value)}
                        placeholder='Enter starting code.'
                      />
                      <div className='thespace'></div>
                      <button className='thewisptebtn' onClick={handleStart}>
                        Start task
                      </button>
                    </div>
                  )}
                  <div className='thespace'></div>
                  <div className='dividar'></div>
                  <div className='thespacee'></div>
                  {task.status === "completed" && !task?.proofimage && (
                    <div
                      className=''
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                      }}
                    >
                      <p className='thewidgptitle'>Upload proof of work</p>
                      <div className='thespace'></div>
                      <div className='inputjobcnt'>
                        <div className='theimageinputcnt'>
                          <div className='custom-file-input'>
                            <input
                              type='file'
                              id='proofuplaod'
                              name='proofimage'
                              accept='.jpg, .png'
                              onChange={handleProofChange}
                            />
                            <label htmlFor='proofuplaod'>
                              <span className='upload-text'>+</span>
                            </label>
                          </div>

                          <div className='preview-container'>
                            {proofFile ? (
                              <div className='preview-item'>
                                {proofFile.file.type === "application/pdf" ? (
                                  <embed
                                    src={proofFile.preview}
                                    type='application/pdf'
                                    height='200px' // 👈 Required: sets display size
                                    className='previewimg'
                                  />
                                ) : (
                                  <img
                                    src={proofFile.preview}
                                    alt='Preview'
                                    className='previewimg'
                                  />
                                )}
                                <button
                                  onClick={handleProfileDeleteImage}
                                  className='imgdeleteicon'
                                >
                                  ×
                                </button>
                              </div>
                            ) : (
                              <p>No file uploaded.</p>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className='thespace'></div>
                      <div className='thewidepas'>
                        <button
                          className='thewisptebtn'
                          onClick={saveProofDetails}
                        >
                          upload proof of completion
                        </button>
                      </div>
                    </div>
                  )}
                  {/* <p style={{ color: "green" }}>
            Task completed successfully. Total time: {task.totalTimeInHours}
            hours
          </p> */}
                  {startTime && !task.completedAt && (
                    <div className='inputjobcnt'>
                      <input
                        type='text'
                        value={completeCode}
                        onChange={(e) => setCompleteCode(e.target.value)}
                        placeholder='Enter completion code'
                      />
                      <div className='thespace'></div>
                      <button className='thewisptebtn' onClick={handleComplete}>
                        Complete Task
                      </button>
                    </div>
                  )}
                  {/* {(task.status === "accepted" ||
                    task.status === "in progress") && (
                    <button
                      className='jdtechopenchat'
                      onClick={() => navigate(`/technician/chat/${taskId}`)}
                    >
                      Open chat
                    </button>
                  )} */}
                  <div className='thespacee'></div>
                  <div className='dividar'></div>
                  <div className='thespace'></div>
                </div>
                <div className='thespacee'></div>
              </div>
            </div>
          </div>
        </div>
        {showChat && (
          <>
            <div className='chatoverlay'></div>
            <div className='bookingpagechatcnt'>
              <div className='aks'>
                <button
                  className='tdtbackk'
                  onClick={() => setShowChatModal(false)}
                >
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    viewBox='0 0 24 24'
                    width='24'
                    height='24'
                    fill='currentColor'
                  >
                    <path d='M10.8284 12.0007L15.7782 16.9504L14.364 18.3646L8 12.0007L14.364 5.63672L15.7782 7.05093L10.8284 12.0007Z'></path>
                  </svg>
                  Back
                </button>
              </div>

              <div className='chatcnt'>
                {messages.map((msg, index) => {
                  const isCurrentUser = msg.sender === auth.currentUser.uid;
                  return (
                    <div
                      key={index}
                      className={
                        isCurrentUser ? "thecurrentuser" : "notthecurrentuser"
                      }
                    >
                      <div
                        className={
                          isCurrentUser ? "thetapisncnt" : "notthetapisncnt"
                        }
                      >
                        <div
                          className={
                            isCurrentUser ? "thetapins" : "notthetapins"
                          }
                        >
                          <p className='thesendername'>{msg.senderName}</p>
                          <p className='thesendertime'>
                            {formatWhatsAppTimestamp(msg.timestamp)}
                          </p>
                        </div>

                        <div
                          className={
                            isCurrentUser
                              ? "thecurrentuserbg"
                              : "notthecurrentuserbg"
                          }
                        >
                          <p>{msg.message}</p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className='thespasl'>
                <div className='thetypemsg'>
                  <input
                    type='text'
                    value={newMsg}
                    placeholder='Type a message..'
                    onChange={(e) => setNewMsg(e.target.value)}
                  />
                  <button className='imgbtn' onClick={sendMessage}>
                    <img src={sendimg} alt='' srcset='' />
                  </button>
                </div>
              </div>
            </div>
          </>
        )}
        {tasksum && (
          <>
            <div className='summodall'></div>
            <div className='sumbodyy'>
              <div className='sumbodycnt'>
                <div className='sumtop'>
                  <button
                    className='profile-close'
                    onClick={() => setTasksum(false)}
                  >
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      viewBox='0 0 24 24'
                      width='32'
                      height='32'
                      fill='#fff'
                    >
                      <path d='M10.5859 12L2.79297 4.20706L4.20718 2.79285L12.0001 10.5857L19.793 2.79285L21.2072 4.20706L13.4143 12L21.2072 19.7928L19.793 21.2071L12.0001 13.4142L4.20718 21.2071L2.79297 19.7928L10.5859 12Z'></path>
                    </svg>
                  </button>
                </div>
                <div className='thespace'></div>
                <h1 className='sumttitle'>Task Summary</h1>
                <div className='thespacee'></div>
                <p className='profidestitle'>Task title</p>
                <div className='thespace'></div>
                <p className='proffdes'>{task.jobtitle}</p>
                <div className='thespacee'></div>
                <p className='profidestitle'>Your task details</p>

                <div className='thespace'></div>
                <p className='proff'>{task.jobdescription}</p>
                <div className='thespace'></div>
                <div className='profitems'>
                  <img src={timeicon} alt='' className='pritemimg' />
                  {task.timeOfDay === "morning" && (
                    <p>
                      {task.timeOfDay} <span>Before 10am</span>
                    </p>
                  )}
                  {task.timeOfDay === "midday" && (
                    <p>
                      {task.timeOfDay} <span>10am - 2pm</span>
                    </p>
                  )}
                  {task.timeOfDay === "afternoon" && (
                    <p>
                      {task.timeOfDay} <span>2pm - 6pm</span>
                    </p>
                  )}
                  {task.timeOfDay === "evening" && (
                    <p>
                      {task.timeOfDay} <span>After 6pm</span>
                    </p>
                  )}
                </div>
                <div className='thespace'></div>
                <div className='profitems'>
                  <img src={timeicon} alt='' className='pritemimg' />
                  <p>
                    Start Time:{" "}
                    <span>{getTimeFromTimestamp(task.startTime)}</span>
                  </p>
                </div>
                <div className='thespace'></div>
                <div className='profitems'>
                  <img src={timeicon} alt='' className='pritemimg' />
                  <p>
                    Finished Time:{" "}
                    <span>{getTimeFromTimestamp(task.pauseTime)}</span>
                  </p>
                </div>
                <div className='thespace'></div>
                <div className='profitems'>
                  <img src={calendericon} alt='' className='pritemimg' />
                  <p>{formatDate(task.date)}</p>
                </div>
                <div className='thespace'></div>
                <div className='profitems'>
                  <img src={locationicon} alt='' className='pritemimg' />
                  <p>{task.address}</p>
                </div>
                <div className='thespacee'></div>
                <div className='divider'></div>
                <div className='thespace'></div>
                <p className='profidestitle'>Price Details</p>
                <div className='thespace'></div>
                <div className='theprdet'>
                  <div className='prodestri'>
                    <p className='prodeslef'>Total hours worked</p>
                    <p className='prodesright'>{task.totalTimeInHours}Hours</p>
                  </div>
                  <div className='prodestri'>
                    <p className='prodeslef'>Hourly rate</p>
                    <p className='prodesright'>
                      ₦{formatPrice(task.hourlyRate)}/hr
                    </p>
                  </div>
                  <div className='prodestri'>
                    <p className='prodeslef'>Trust/support fee</p>
                    <p className='prodesright'> ₦8,000</p>
                  </div>
                  <div className='prodestri'>
                    <p className='prodeslef'>Total fee</p>
                    <p className='prodesright'>
                      ₦
                      {formatPrice(
                        task.hourlyRate * task.totalTimeInHours +
                          task.trustSupportFee
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </TechnicianDashboardLayout>
    </>
  );
}

export default TaskDetails;
